// PrivateRoutes.jsx
import { useAuth } from "./AuthContext";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoutes = () => {
    const { user } = useAuth();

    // console.log("PrivateRoutes user:", user);

    return user ? <Outlet /> : <Navigate to="/signup" />;
};

export default PrivateRoutes;
